import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from 'react-native'
import ObjectRenderer from './ObjectRenderer'

export default class ComponentInstance extends Component {
  static contextTypes = {
    getApp: PropTypes.func,
  }

  getComponent = () => {
    let { object } = this.props
    let { getApp } = this.context
    let { componentId } = object.attributes

    let app = getApp()
    let component = app.components[componentId]

    return component
  }

  render() {
    let { object, active, topScreen } = this.props
    let { layout } = object

    let component = this.getComponent()

    if (!component) {
      return null
    }

    let children = component.layout.body

    return (
      <View style={[styles.wrapper, layout]}>
        {children.map(obj => (
          <ObjectRenderer
            isReusableComponent
            key={obj.id}
            object={obj}
            component={component}
            active={active}
            topScreen={topScreen}
          />
        ))}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  wrapper: {},
})
